// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"946998af","729":"61c75061","776":"6bf9c63d","998":"0a0f0f94"}[chunkId] + ".chunk.js";
};